import React, { useState, useCallback } from 'react';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import DrawerBody from 'components/ui/DrawerBody';
import { connect } from 'react-redux';
import SuccessFace from 'components/ui/AnimatedStates/SuccessFace';
import ErrorFace from 'components/ui/AnimatedStates/ErrorFace';
import LoadingFace from 'components/ui/AnimatedStates/LoadingFace';

import EventForm from './EventForm/Eventform';

import { getTranslatedString } from 'helpers/i18n';

import { createEvent } from './store/actions';

const FORM_NAME = 'create_event_form';

const CREATING_STATES = {
  form: 'form',
  loading: 'loading',
  success: 'success',
  error: 'error',
};

const CreateEvent = ({ handleClose, createEvent }) => {
  const [creatingState, setCreatingState] = useState(CREATING_STATES.form);
  const [tempValues, setTempValues] = useState({});

  const handleCreateEvent = useCallback(
    async values => {
      setCreatingState(CREATING_STATES.loading);
      try {
        // if the request fails, store the values temporarily to retry
        setTempValues(values);
        await createEvent(values);
        setTempValues({});
        setCreatingState(CREATING_STATES.success);
      } catch (err) {
        setCreatingState(CREATING_STATES.error);
      }
    },
    [createEvent]
  );

  const handleRetry = useCallback(
    () => {
      handleCreateEvent(tempValues);
    },
    [handleCreateEvent, tempValues]
  );

  if (creatingState === CREATING_STATES.form) {
    return <FormFace handleClose={handleClose} handleCreateEvent={handleCreateEvent} />;
  } else if (creatingState === CREATING_STATES.loading) {
    return (
      <LoadingFace
        headerText={getTranslatedString('landlordPortal.events.createLoading')}
        bodyText={getTranslatedString('globalDrawer.loadingBody')}
      />
    );
  } else if (creatingState === CREATING_STATES.success) {
    return (
      <SuccessFace
        onClick={() => {
          setCreatingState(CREATING_STATES.form);
          handleClose();
        }}
        headerText={getTranslatedString('landlordPortal.events.createSuccess')}
        bodyText={getTranslatedString('globalDrawer.successBody')}
        buttonText={getTranslatedString('close')}
      />
    );
  } else if (creatingState === CREATING_STATES.error) {
    return (
      <ErrorFace
        headerText={getTranslatedString('landlordPortal.events.createError')}
        bodyText={getTranslatedString('globalDrawer.errorBody')}
        onClick={() => {
          setCreatingState(CREATING_STATES.form);
          handleClose();
        }}
        buttonText={getTranslatedString('close')}
        onSecondaryClick={handleRetry}
        secondaryButtonText={getTranslatedString('globalDrawer.goBack')}
      />
    );
  }
};

const FormFace = ({ handleClose, handleCreateEvent }) => {
  return (
    <React.Fragment>
      <DrawerHeader
        onClose={handleClose}
        title={getTranslatedString('landlordPortal.events.createNewEvent')}
        subHeader={getTranslatedString('landlordPortal.events.requiredField')}
      />
      <DrawerBody>
        <EventForm formName={FORM_NAME} formData={{}} handleSubmit={handleCreateEvent} />
      </DrawerBody>
      <DrawerFooter
        primaryActionFormName={FORM_NAME}
        primaryActionText={getTranslatedString('create')}
      />
    </React.Fragment>
  );
};

const mapStoreToProps = store => ({});

const mapDispatchToProps = {
  createEvent,
};

export default connect(mapStoreToProps, mapDispatchToProps)(CreateEvent);
